import byPageMaker from 'reducersMakers/byPageMaker';
import * as actions from 'actions';

export default byPageMaker([
  actions.MAGAZINE_ARTICLES_FETCH_SUCCESS,
  actions.MAGAZINE_SIDEBAR_ARTICLES_FETCH_SUCCESS
], 'magazineArticlesIds');



/** WEBPACK FOOTER **
 ** ./src/members/state/magazine/magazineArticles/byQuery/byPage/reducer.js
 **/